import { FormBuilder } from "../../../../types/FormBuilderInterfaces";
import CollapseItem from "../../components/CollapseItem";
import PageSettings from "./components/PageSettings";

import PostSubmit from "./components/PostSubmit";
import SpamProtection from "./components/SpamProtection";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const SettingsTab = ({ form, setForm }: Props) => {
  const collapseItems = [
    {
      title: "Page Settings",
      children: <PageSettings form={form} setForm={setForm} />,
    },
    {
      title: "Post Submit",
      children: <PostSubmit form={form} setForm={setForm} />,
    },
    {
      title: "Spam Protection",
      children: <SpamProtection form={form} setForm={setForm} />,
    },
  ];
  return (
    <>
      {collapseItems.map((collapseItem) => {
        return (
          <CollapseItem
            title={collapseItem.title}
            children={collapseItem.children}
            key={collapseItem.title}
            defaultOpen={false}
          />
        );
      })}
    </>
  );
};

export default SettingsTab;
